import type { TProductForCart } from 'actions/cart';
import type { TPrice } from 'types/product';

export function orderMobileImages(data: TODO[]) {
  if (!data || !Array.isArray(data)) return [];
  if (data.length === 0) return [];
  const imagesForProductSheet = [...data];

  if (imagesForProductSheet) {
    const [firstImage, secondImage, thirdImage, fourthImage] = data;

    if (imagesForProductSheet.length > 1) {
      imagesForProductSheet[0] = secondImage;
      imagesForProductSheet[1] = firstImage;
    }

    if (imagesForProductSheet.length > 3) {
      imagesForProductSheet[2] = fourthImage;
      imagesForProductSheet[3] = thirdImage;
    }
  }
  return imagesForProductSheet;
}

export function combineTwoShoesPrices({ shoeOnePrice, shoeTwoPrice }: { shoeOnePrice: TPrice; shoeTwoPrice: TPrice }) {
  if (!shoeOnePrice && !shoeTwoPrice) {
    return null;
  }
  if (!shoeOnePrice && shoeTwoPrice) {
    return shoeTwoPrice;
  }
  if (shoeOnePrice && !shoeTwoPrice) {
    return shoeOnePrice;
  }

  return {
    current: (shoeOnePrice.current ?? 0) + (shoeTwoPrice.current ?? 0),
    currentEur: (shoeOnePrice.currentEur ?? 0) + (shoeTwoPrice.currentEur ?? 0),
    currency: shoeOnePrice.currency,
    currencySap: shoeOnePrice.currencySap,
    discountEur: (shoeOnePrice.discountEur ?? 0) + (shoeTwoPrice.discountEur ?? 0),
    discountLocal: (shoeOnePrice.discountLocal ?? 0) + (shoeTwoPrice.discountLocal ?? 0),
    pricePerSize: shoeOnePrice.pricePerSize,
    currentFormated: new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: shoeOnePrice.currencySap ?? 'EUR',
    }).format((shoeOnePrice.current ?? 0) + (shoeTwoPrice.current ?? 0)),
  };
}

const endSkuRegex = /[A-Z0-9]+(?:-[0-9]{1,3})?-[A-Z0-9]{3,5}$/;

export function extractSku(text?: string) {
  if (typeof text !== 'string') return null;
  const match = text.match(endSkuRegex);
  return match ? match[0] : null;
}

const onlySkuRegex = /([A-Z0-9]+(?:-[0-9]{1,3})?-[A-Z0-9]{3,5})(-[a-zA-Z0-9]{1,2})?/;

export function getProductsFromQuery(query: string | undefined): Pick<TProductForCart, 'id' | 'size'>[] {
  if (query === undefined) return [];
  if (query === '') return [];
  // si el query no tiene el formato correcto, devolvemos un array vacio

  return decodeURIComponent(query)
    .split(',')
    .reduce(
      (acc, item) => {
        const [skuAndSize, quantity] = item.split(':');
        let numberQuantity = Number(quantity);

        if (isNaN(numberQuantity) || numberQuantity <= 0) {
          numberQuantity = 1;
        }
        // el cada producto viene como {sku}-{size}:{quantity}. Sku tiene formato de K201767-001 y el size puede ser 1 character o 2 o no llegar. Necesitamos un regex para separar el sku y el size
        const regexResult = onlySkuRegex.exec(skuAndSize ?? '');

        if (regexResult) {
          const [_, sku, size] = regexResult;

          // por cada cantidad de producto añadimos al array el producto
          new Array(Number(quantity)).fill(0).forEach(() => {
            acc.push({
              id: sku ?? '',
              size: !size ? '' : size.substring(1), // remove the dash
              // thumbnail: `https://cloud.camper.com/is/image/JGVzaG9wMDNiYWdncmV5JA==/${sku}_L.jpg`,
            });
          });
        }

        return acc;
      },
      [] as Pick<TProductForCart, 'id' | 'size'>[],
    );
}
